/* @moldura padrao */
import { Link } from 'react-router-dom';
import { useAuth } from '@/auth/auth-context';
import { CustomConviteInstalar } from '@/components/CustomConviteInstalar';
import { CustomMolduraPagina } from '@/components/CustomMolduraPagina';

// Cada atalho declara a PERMISSÃO que o abre — a mesma string que trava a rota
// e desenha o menu lateral. Sem isso, o instalador abria o app e via um cartão
// "Usuários" que ele não pode abrir: atalho que dá 403 é pior que atalho nenhum,
// e ocupa o lugar do que ele realmente usa.
//
// Até 19/08/2026 isto filtrava por `secao`, e ficou para trás quando o menu
// passou a rodar por permissão — a tela inicial e o menu podiam discordar na
// cara do usuário.
const ATALHOS = [
  {
    to: '/ordens-servico',
    icon: 'bi-clipboard-check',
    nome: 'Ordens de Serviço',
    permissao: 'ordens-servico.proprias.ver',
  },
  { to: '/agenda/instalacoes', icon: 'bi-calendar-week', nome: 'Agenda', permissao: 'agenda.visitas.ver' },
  { to: '/despesas/nova', icon: 'bi-receipt', nome: 'Lançar despesa', permissao: 'despesas.lancamento.lancar' },
  // PEDIR AUTORIZAÇÃO — pedido dele em 01/09/2026, Fase 4b da ficha #26: um
  // botão direto no celular, "porque quem mais pede é o instalador".
  //
  // Aqui, e não na barra de atalhos do rodapé: aquela corta em quatro, e o
  // quinto a entrar empurraria a OS para fora — justamente o atalho que o
  // instalador usa. A tela inicial não tem esse teto.
  //
  // Aponta para o FORMULÁRIO, não para a lista, pela mesma razão do "Lançar
  // despesa": quem abre o app para pedir não quer passar por uma lista antes.
  // E a permissão é `abrir`, não `fila.ver` — o instalador pede autorização e
  // não enxerga a fila de ninguém (escopo de linha, Fase 3b).
  { to: '/autorizacoes/nova', icon: 'bi-hand-thumbs-up', nome: 'Pedir autorização', permissao: 'autorizacoes.pedido.abrir' },
  { to: '/viagens', icon: 'bi-truck', nome: 'Viagens', permissao: 'viagens.viagem.ver' },
  { to: '/usuarios', icon: 'bi-people', nome: 'Usuários', permissao: 'usuarios.contas.ver' },
];

export function InicioPage() {
  const { usuario, pode } = useAuth();
  const atalhos = ATALHOS.filter((a) => !a.permissao || pode(a.permissao));

  /* A COR ALTERNA PELA POSIÇÃO FINAL, não por um campo no array.
     Ela era fixa em cada item até 10/09/2026 — e como a lista é FILTRADA por
     permissão, a alternância só valia para quem via tudo (o admin, que é quem
     sempre olha). O instalador via OS e Lançar despesa, dois `theme-1`
     seguidos, e a fileira parecia um bloco só. Derivar do índice acerta para
     todo perfil, e tira do array um campo que só tinha como divergir. */
  const cor = (i: number) => (i % 2 === 0 ? 'theme-1' : 'theme-2');
  return (
    <CustomMolduraPagina
      titulo={`Olá, ${usuario?.nome?.split(' ')[0] ?? 'bem-vindo'}`}
      descricao="Casa A — operação (Búzios / Trancoso)"
      /* A RAIZ NÃO TEM BREADCRUMB: `Início › Olá, Fulano` não informa nada —
         diria que a tela pende dela mesma. */
      semCaminho
    >

      <CustomConviteInstalar />

      <div className="row g-3">
        {atalhos.map((a, i) => (
          <div className="col-6 col-lg-3" key={a.to}>
            <Link to={a.to} className="text-decoration-none">
              <div className="card adminuiux-card h-100">
                <div className="card-body text-center py-4">
                  {/* `bg-*-subtle`, e não `bg-* bg-opacity-10`: as classes de
                      tema do AdminUX pintam o fundo com cor SÓLIDA e ignoram o
                      `--bs-bg-opacity` do Bootstrap, então o ícone azul ficava
                      invisível sobre um círculo azul. O resto do app (header,
                      sidebar, notificações) já usa `subtle`. */}
                  <div
                    className={`avatar avatar-50 rounded-circle bg-${cor(i)}-subtle text-${cor(i)} mx-auto mb-2 d-flex align-items-center justify-content-center`}
                  >
                    <i className={`bi ${a.icon} h4 mb-0`}></i>
                  </div>
                  <h6 className="mb-0">{a.nome}</h6>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </CustomMolduraPagina>
  );
}
